import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { TerminalViewModel } from "../models/terminal-view-model";
import { CreateResult } from "../models/create-result";
import { TaTermConfigViewModel } from "../models/ta-term-config-view-model";
import { TermTypeViewModel } from "../models/term-type-view-model";
import { CapabilityProfileViewModel } from "../models/capability-profile-view-model";
import { CommsProfileViewModel } from "../models/comms-profile-view-model";
import { AddUpdateTerminalViewModel } from "../models/add-update-terminal-view-model";
import { TerminalInteractionViewModel } from "../models/terminal-interaction-view-model";
import { AddUpdateTerminalInteractionViewModel } from '../models/add-update-terminal-interaction-view-model';
import { InteractionTypeEnum } from '../models/interaction-type-enum';
import { TerminalParamViewModel } from "../models/terminal-param-view-model";
import { TerminalInteractionsViewModel } from '../models/terminal-interactions-view-model';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommsProfileParticipantLinkViewModel } from "../models/comms-profile-participant-link";
import { CardSetsViewModel } from "../models/card-set";
import { TerminalTrackingViewModel } from '../models/terminal-tracking-view-model';
import { WaybillResponseViewModel } from '../models/waybill-response-view-model';
import { TerminalContactsViewModel } from '../models/terminal-contacts-view-model';
import { TerminalSignUpViewModel } from '../models/terminal-signup-view-model';
import { MerchantSignUpViewModel } from '../models/merchant-sign-up-view-model';
import { DeviceMakeViewModel } from '../models/device-make-view-model';
import { DeviceModelViewModel } from '../models/device-model-view-model';
import { AddUpdateTerminalSignUpViewModel } from '../models/add-update-terminal-sign-up-view-model';
import { debug } from 'util';
import { TerminalBulkOrderViewModel } from '../models/termina-bulk-order-view-model';
import { TerminalSignUpNotesViewModel } from '../models/terminal-sign-up-notes';
import { DeleteTerminalSignUpViewModel } from '../models/delete-teminal-singup-view-model';
import { AddUpdateESocketViewModel } from '../models/add-update-eSocket-view-model';
import { TerminalDetailModel } from '../models/terminal-detail-model';
import { TerminalInfoModel } from '../models/terminal-info-model';
import { AddUpdateTerminalLogViewModel } from '../models/add-update-terminal-log-view-model';
import { ResultMessageViewModel } from '../models/result-message-view-model';
import { HttpHeaders, ɵHttpInterceptingHandler } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TerminalService {
  
   
  private countSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private tsuCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0); 
  public get count(): number {
    return this.countSubject.value;
  }
  public set count(value) {
    this.countSubject.next(value);
  }
  public get countObservable(): Observable<number> {
    return this.countSubject.asObservable();
  }



  public get getTerminalSignedUpCount(): number {
    return this.tsuCountSubject.value;
  }
  public set getTerminalSignedUpCount(value) {
    this.tsuCountSubject.next(value);
  }
  public get GetTerminalSignedUpCountObservable(): Observable<number> {
    return this.tsuCountSubject.asObservable();
  }




  private countActiveSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get countActive(): number {
    return this.countActiveSubject.value;
  }

  public set countActive(value) {
    this.countActiveSubject.next(value);
  }

  public get countActiveObservable(): Observable<number> {
    return this.countActiveSubject.asObservable();
  }

  private countInactiveSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get countInactive(): number {
    return this.countInactiveSubject.value;
  }

  public set countInactive(value) {
    this.countInactiveSubject.next(value);
  }

  public get countInactiveObservable(): Observable<number> {
    return this.countInactiveSubject.asObservable();
  }

  constructor(private _httpService: HttpService) {
    this.InitCounts();
  }

  public async InitCounts(): Promise<void> {
    await this.InitTerminalCount();
    await this.InitTerminalCountActive();
    await this.InitTerminalCountInactive();
    await this.InitTerminalSignedUpCountByParticipantId()
  }

  public async GetAllTerminals(): Promise<TerminalViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalViewModel[]>(`terminal/all`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalsAllByMerchantId(merchantNumber: string): Promise<TerminalViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalViewModel[]>(`terminal/TerminalsByMerchant/${merchantNumber}`);
    if (httpResult && httpResult.body) {

      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalSignedUpType(serialNumber: string): Promise<ResultMessageViewModel> {
    const httpResult = await this._httpService.apiGet<ResultMessageViewModel>(`terminal/GetTerminalSignedUpType/${serialNumber}`, { responseType: 'text' });
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }

  public async GetDeviceMakes(): Promise<DeviceMakeViewModel[]> {
    const httpResult = await this._httpService.apiGet<DeviceMakeViewModel[]>(`terminal/deviceMake`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetSerialNumber(terminalId: string): Promise<string> {
    const httpResult = await this._httpService.apiGet<string>(`terminal/getSerialNumber/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }


  public async GetDeviceModelsByDeviceId(deviceId: number): Promise<DeviceModelViewModel[]> {
    const httpResult = await this._httpService.apiGet<DeviceModelViewModel[]>(`terminal/DeviceModels/${deviceId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetLastTermNumber(merchantId: string): Promise<number> {
    const httpResult = await this._httpService.apiGet<number>(`terminal/GetLastTermNumber/${merchantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }


  public async GetDeviceModels(): Promise<DeviceModelViewModel[]> {
    const httpResult = await this._httpService.apiGet<DeviceModelViewModel[]>(`terminal/DeviceModels`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetTerminalView(terminalId: string): Promise<TerminalViewModel> {
    const httpResult = await this._httpService.apiGet<TerminalViewModel>(`terminal/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetTerminalDetails(terminalId: string): Promise<TerminalDetailModel> {
    const httpResult = await this._httpService.apiGet<TerminalDetailModel>(`terminal/terminalDetails/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetTerminalInfo(terminalId: string): Promise<TerminalInfoModel> {
    const httpResult = await this._httpService.apiGet<TerminalInfoModel>(`terminal/terminalInfo/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetESocketTerminalDetails(terminalId: string): Promise<AddUpdateESocketViewModel> {
    const httpResult = await this._httpService.apiGet<AddUpdateESocketViewModel>(`terminal/GetESocketTerminal/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
}

  public async GetMerchantTerminalTrackingByTerminalId(terminalId: string): Promise<TerminalSignUpViewModel> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel>(`terminal/tracking/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetMerchantTerminalTrackingInforByMerchant(merchantNumber: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/tracking/all/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalsByCommsProfile(commsProfile: number): Promise<TerminalViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalViewModel[]>(`terminal/TerminalsByCommsProfile/${commsProfile}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async CountTerminals(commsProfile: number): Promise<number> {
    const httpResult = await this._httpService.apiGet<number>(`terminal/CountTerminals/${commsProfile}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return 0;
  }

  public async GetCommsProfileByParticipant(id: number): Promise<CommsProfileViewModel[]> {

    const httpResult = await this._httpService.apiGet<CommsProfileViewModel[]>(`terminal/CommsProfileByParticipant/${id}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async InitTerminalSignedUpCountByParticipantId(): Promise<void> {
    this.tsuCountSubject = new BehaviorSubject<number>(0);
    const httpResult = await this._httpService.apiGet<number>(`terminal/GetTerminalSignedUpCountByParticipantId`);
    if (httpResult && httpResult.body) {
      this.getTerminalSignedUpCount = httpResult.body;
    }
  }

  public async InitTerminalCount(): Promise<void> {
    this.countSubject = new BehaviorSubject<number>(0);
    const httpResult = await this._httpService.apiGet<number>(`terminal/count`);
    if (httpResult && httpResult.body) {
      this.count = httpResult.body;
    }
  }

  public async InitTerminalCountActive(): Promise<void> {
    this.countActiveSubject = new BehaviorSubject<number>(0);
    const httpResult = await this._httpService.apiGet<number>(`terminal/count-active`);
    if (httpResult && httpResult.body) {
      this.countActive = httpResult.body;
    }
  }

  public async InitTerminalCountInactive(): Promise<void> {
    this.countInactiveSubject = new BehaviorSubject<number>(0);
    const httpResult = await this._httpService.apiGet<number>(`terminal/count-inactive`);
    if (httpResult && httpResult.body) {
      this.countInactive = httpResult.body;
    }
  }

  public async Get(id: string): Promise<TerminalViewModel> {
    const httpResult = await this._httpService.apiGet<TerminalViewModel>(`terminal/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async TerminalNumberExists(terminalNumber: number, merchantNumber: string): Promise<boolean> {
    const httpResult = await this._httpService.apiGet<boolean>(`terminal/TerminalNumberExists/${terminalNumber}/${merchantNumber}`);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return false;
  }

  public async IsSerialNrVisible(participantId: number): Promise<boolean> {
    const httpResult = await this._httpService.apiGet<boolean>(`terminal/IsSerialNrVisible/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return false;
  }

  public async GetTerminalSignedUpByMerchant(merchantNumber: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/TerminalsSignedUp/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetBulkTerminalSignedUpByMerchant(merchantNumber: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/BulkTerminalsSignedUp/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalSignedUpBySerialNumber(merchantNumber: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/GetTerminalSignedUpBySerialNumber/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetBulkTerminalSignedUpByMerchantNotInStatus(merchantNumber: string, status: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/GetBulkTerminalSignedUpByMerchantNotInStatus/${merchantNumber}/${status}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetBulkTerminalSignedUpByMerchantStatus(merchantNumber: string, status: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/BulkTerminalsSignedUp/${merchantNumber}/${status}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetBulkArchivedTerminalSignedUpByMerchant(merchantNumber: string): Promise<TerminalSignUpViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/BulkArchivedTerminalsSignedUp/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalSignedUpById(terminalId: string): Promise<TerminalSignUpViewModel> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel>(`terminal/TerminalSignedUp/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetArchivedTerminalSignedUpById(terminalId: string): Promise<TerminalSignUpViewModel> {
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel>(`terminal/ArchivedTerminalSignedUp/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async getTerminalBulkOrderList(merchantNumber: string): Promise<TerminalBulkOrderViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalBulkOrderViewModel[]>(`terminal/TerminalBulkOrder/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalsByMerchantNumber(merchantNumber: string): Promise<TerminalViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalViewModel[]>(`terminal/TerminalCountByMerchant/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetTaTermCfg(id: string): Promise<TaTermConfigViewModel> {
    const httpResult = await this._httpService.apiGet<TaTermConfigViewModel>(`terminal/${id}/TATermConfig`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetTermTypes(): Promise<TermTypeViewModel[]> {
    const httpResult = await this._httpService.apiGet<TermTypeViewModel[]>(`terminal/TermTypes`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetCapabilityProfiles(): Promise<CapabilityProfileViewModel[]> {
    const httpResult = await this._httpService.apiGet<CapabilityProfileViewModel[]>(`terminal/CapabilityProfiles`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async Update(terminal: AddUpdateTerminalViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/Update/${terminal.terminalId}`, terminal);

    if (httpResult && httpResult.body) {
      return httpResult.body;
      this.InitCounts();
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async Create(terminal: AddUpdateTerminalViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/Create`, terminal);
    debugger;
    if (httpResult && httpResult.body) {
      if (httpResult.body.success == true) {
        this.InitCounts();
      }      
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to create a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddMutlipleTerminals(terminals: AddUpdateTerminalSignUpViewModel[], deliveryAddress: string): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddTerminals/${deliveryAddress}`, terminals);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddMutlipleDevicesRequests(terminals: AddUpdateTerminalSignUpViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/DeviceRequest`, terminals);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateTerminalTracking(terminals: TerminalSignUpViewModel, dispatch: boolean): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/updateTerminalTracking/${dispatch}`, terminals);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateTerminalSignedUp(terminal: TerminalSignUpViewModel, dispatch: boolean): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/updateTerminalSignedUp/${dispatch}`, terminal);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateTerminalsSignedUp(terminals: TerminalSignUpViewModel[], dispatch: boolean): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/updateTerminalsSignedUp/${dispatch}`, terminals);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async ArchiveTerminalSignUp(terminals: TerminalSignUpViewModel, isBulk: boolean): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/archiveTerminalSignUp/${isBulk}`, terminals);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async ResetTerminalSignUp(terminals: TerminalSignUpViewModel, isBulk: boolean): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/resetTerminalSignUp/${isBulk}`, terminals);

    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateTerminalDetails(terminalDetails: TerminalDetailModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/UpdateTerminalDetails`, terminalDetails);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddUpdateTerminalInfo(terminalInfo: TerminalInfoModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddUpdateTerminalInfo`, terminalInfo);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddTerminalInfo(terminalInfo: TerminalInfoModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddTerminalInfo`, terminalInfo);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async ValidateEsocketTerminal(eSocketTerminal: AddUpdateESocketViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/ValidateEsocketTerminal`, eSocketTerminal);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddTerminalContacts(terminals: TerminalContactsViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddTerminalContacts/`, terminals);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };

  }

  public async SendNotification(terminals: AddUpdateTerminalViewModel[], type: string): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/SendNotification/${type}/`, terminals);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async RetrySendNotification(terminals: TerminalSignUpViewModel, type: string): Promise<CreateResult> {
    
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/RetrySendingNotification/${type}/`, terminals);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddTerminalSignUpNote(terminalsNotes: TerminalSignUpNotesViewModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddTerminalSignUpNote/`, terminalsNotes);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteTicket(terminal: DeleteTerminalSignUpViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/DeleteTicket/`, terminal);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetTerminalSignUpNote(merchantId: string, terminalId: string): Promise<TerminalSignUpNotesViewModel[]> {

    const httpResult = await this._httpService.apiGet<TerminalSignUpNotesViewModel[]>(`terminal/TerminalSignUpNotes/${terminalId}/${merchantId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetTerminalSignUpNoteByBulk(merchantId: string): Promise<TerminalSignUpNotesViewModel[]> {

    const httpResult = await this._httpService.apiGet<TerminalSignUpNotesViewModel[]>(`terminal/TerminalSignUpNoteByBulk/${merchantId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async TerminalCardStatus(terminalId: string): Promise<WaybillResponseViewModel> {

    const httpResult = await this._httpService.apiGet<WaybillResponseViewModel>(`terminal/TerminalsTracking/${terminalId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { status_description: "You do not have the permission to update a terminal. Please contact system administrator.", status_code: 500, tracking_information: null }
    }
    return { status_description: "An unknown error occured", status_code: 500, tracking_information: null };
  }

  public async GetTerminalContacts(terminalId: string): Promise<TerminalContactsViewModel> {

    const httpResult = await this._httpService.apiGet<TerminalContactsViewModel>(`terminal/GetTerminalContacts/${terminalId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetQRCode(wayBill: string): Promise<Uint8Array> {
    const httpResult = await this._httpService.apiGet<Uint8Array>(`terminal/GetQrCode/${wayBill}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetBarCode(wayBill: string): Promise<any> {//Uint8Array
    const httpResult = await this._httpService.apiGet<any>(`terminal/GetBarCode/${wayBill}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async TerminalsExists(terminals: AddUpdateTerminalViewModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/TerminalsExists/`, terminals);
    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async TerminalExists(terminalId: string): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`terminal/GetTerminal/${terminalId}`);
    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }


  public async TerminalsTracking(wayBill: string): Promise<WaybillResponseViewModel> {

    const httpResult = await this._httpService.apiGet<WaybillResponseViewModel>(`terminal/TerminalsTracking/${wayBill}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { status_description: "You do not have the permission to update a terminal. Please contact system administrator.", status_code: 500, tracking_information: null }
    }
    return { status_description: "An unknown error occured", status_code: 500, tracking_information: null };
  }

  public async DispatchTerminal(serialNumber: string): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`terminal/dispatchTerminal/${serialNumber}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetDispatchedTerminal(): Promise<TerminalSignUpViewModel[]> {

    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`terminal/getDispatchedTerminal/`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }


  public async GetTerminalInteractions(terminalId: string): Promise<TerminalInteractionViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalInteractionViewModel[]>(`terminal/${terminalId}/interactions`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return []
  }

  public async GetTerminalInteractionsDetails(terminalId: string): Promise<TerminalInteractionsViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalInteractionsViewModel[]>(`terminal/${terminalId}/interactionsDetails`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return []
  }

  public async AddTerminalInteractions(interactionType: InteractionTypeEnum, terminal: AddUpdateTerminalInteractionViewModel): Promise<CreateResult> {
    debugger;
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/TerminalInteraction/${interactionType}`, terminal);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to add terminal interaction. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddUpdateTerminalInteractions(interactionType: InteractionTypeEnum, terminal: AddUpdateTerminalInteractionViewModel): Promise<CreateResult> {
    debugger;
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddUpdateTerminalInteraction/${interactionType}`, terminal);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddUpdateAllTerminalInteractions(terminal: AddUpdateTerminalInteractionViewModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/AddUpdateAllTerminalInteraction`, terminal);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async ActivateTerminalsByMerchantNr(terminals: AddUpdateTerminalSignUpViewModel[]): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/ActivateTerminalsByMerchantNr`, terminals);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateTerminalInteraction(interactionType: InteractionTypeEnum, terminal: AddUpdateTerminalInteractionViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/TerminalInteractionUpdate/${interactionType}`, terminal);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteInactiveTerminal(terminalId: string): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/${terminalId}/DeleteInactiveTerminal`, terminalId);
    if (httpResult && httpResult.body) {
      this.InitCounts();
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to delete a terminal. Please contact system administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetLastContactlessParam(terminalId: string): Promise<TerminalParamViewModel> {
    const httpResult = await this._httpService.apiGet<any>(`terminal/${terminalId}/TATermParam/TokenCless`);
    debugger;
    if (httpResult && httpResult.body) {

      return httpResult.body;
    }
    return null;
  }

  public async SetTerminalParam(termParam: TerminalParamViewModel): Promise<any> {
    const httpResult = await this._httpService.apiPost<any>(`terminal/CreateTermParam`, termParam);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Contact System administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }


  public async CreateESocket(additionalterminalInfo: AddUpdateESocketViewModel ): Promise<any> {
    const httpResult = await this._httpService.apiPost<any>(`terminal/CreateEScoketTerminal`, additionalterminalInfo);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Contact System administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateESocket(additionalterminalInfo: AddUpdateESocketViewModel): Promise<any> {
    const httpResult = await this._httpService.apiPut<any>(`terminal/UpdateEScoketTerminal`, additionalterminalInfo);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Contact System administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }


  public async SetCustomParameters(termParams: TerminalParamViewModel[]): Promise<any> {

    const httpResult = await this._httpService.apiPost<any>(`terminal/CreateCustomParams`, termParams);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Contact System administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async SetCustomParameter(termParam: TerminalParamViewModel): Promise<any> {

    const httpResult = await this._httpService.apiPost<any>(`terminal/CreateCustomParam`, termParam);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Contact System administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }

  public async LogTerminalInfor(terminalLog: AddUpdateTerminalLogViewModel): Promise<CreateResult> {
    var token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJab2hvIiwianRpIjoiOTY0NDU1YWMtMGU1Yy00N2ViLTg4ZWItMGQxOTdhOGYzYzVhIiwiZXhwIjo0ODk5Nzk0MDEzLCJpc3MiOiJodHRwczovL2Fjcy1zYS5jb20iLCJhdWQiOiJodHRwczovL2Fjcy1zYS5jb20ifQ.rvwAZfM6fvJi9ifEVGBwKVyvTJIPbDQFw8I0cpFe4Mo';

    const httpResult = await this._httpService.apiPost<CreateResult>(`terminal/CreateTerminalLog/${token}`, terminalLog);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    else if (httpResult.error["status"] == 403) {
      return { message: "You do not have the permission to update terminal permission. Contact System administrator.", success: false }
    }
    return { message: "An unknown error occured", success: false };
  }
}
